module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-lightest radius-normal border-light d-flex flex-column text-center mt-2 py-2"
  }, [(_vm.isFirstTime) ? _c('div', {
    staticClass: "d-flex flex-column justify-content-center align-items-center min-height-price-loading"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Loading prices")]), _vm._v(" "), _c('loader', {
    attrs: {
      "size": "small"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isPricePerGroup || _vm.isPricePerGroupTierPrice) ? _c('div', {
    staticClass: "d-flex justify-content-start ml-3 mb-2 bold"
  }, [_vm._v("\n        " + _vm._s(_vm.isPricePerGroup ? 'Price per Group' : 'Price per Category Tier') + "\n        "), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('This reservation has special prices depending on the number of people.'),
      expression: "'This reservation has special prices depending on the number of people.'"
    }],
    staticClass: "fa fa-info-circle largest color-1 pt-1 ml-2"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row flex-wrap"
  }, _vm._l((_vm.bookingGenderPricesFiltered), function(personPrice, index) {
    return _c('div', {
      key: index,
      staticClass: "col-sm-4 pt-2 pb-2"
    }, [(_vm.showThisGenderPrice(personPrice)) ? _c('div', [_c('div', [_c('div', {
      staticClass: "font-weight-600"
    }, [_vm._v(_vm._s(_vm.genderPriceName(personPrice)))]), _vm._v(" "), _c('div', {}, [_vm._v(_vm._s(_vm.genderPriceDescription(personPrice)))])]), _vm._v(" "), (_vm.refreshCategoryPrices) ? _c('div', {
      staticClass: "d-flex justify-content-center align-items-center",
      class: {
        'prices-height': _vm.reservation.bookingGenderPrices[0].genderPriceType !== 1
      }
    }, [(_vm.getIsLoadingCalculations && _vm.reservation.bookingGenderPrices[0].genderPriceType !== 1) ? _c('loader', {
      attrs: {
        "size": "small"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.getReservationCalculations && !_vm.getIsLoadingCalculations) ? _c('div', {
      staticClass: "d-flex flex-column align-itmes-center justify-content-center"
    }, [(_vm.getPriceGroupOldPrice(personPrice) && _vm.isToShowPerGroupPrices) ? _c('div', {
      staticClass: "dark fs-small bold color-6",
      staticStyle: {
        "text-decoration": "line-through"
      }
    }, [_vm._v("\n                            " + _vm._s(_vm.formatPrice(_vm.getPriceGroupOldPrice(personPrice))) + " €\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.reservation.bookingGenderPrices[0].genderPriceType !== 1) ? _c('div', {
      staticClass: "dark"
    }, [_vm._v("\n                            " + _vm._s(_vm.formatPrice(_vm.showTicketPrice(_vm.findPersonPriceInReservationCalculation(personPrice.id)))) + " €\n                        ")]) : _vm._e()]) : _vm._e()], 1) : _c('div', {
      staticClass: "d-flex justify-content-center align-items-center",
      class: {
        'prices-height': _vm.reservation.bookingGenderPrices[0].genderPriceType !== 1
      }
    }, [(_vm.getIsLoadingCalculations && _vm.reservation.bookingGenderPrices[0].genderPriceType !== 1) ? _c('loader', {
      attrs: {
        "size": "small"
      }
    }) : _vm._e(), _vm._v(" "), ((_vm.reservation.bookingGenderPrices[0].genderPriceType !== 1) && !_vm.getIsLoadingCalculations) ? _c('div', {
      staticClass: "dark"
    }, [_vm._v("\n                        " + _vm._s(_vm.formatPrice(_vm.showTicketPrice(personPrice))) + " €")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "mt-2"
    }, [_c('button', {
      staticClass: "btn fs-largest bg-lightest dark border-medium py-1 px-3 h-100",
      attrs: {
        "disabled": _vm.readOnly
      },
      on: {
        "click": function($event) {
          return _vm.subtractPerson(personPrice)
        }
      }
    }, [_vm._v(" - ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (personPrice.quantityToBook),
        expression: "personPrice.quantityToBook",
        modifiers: {
          "number": true
        }
      }, {
        name: "numInt",
        rawName: "v-numInt"
      }],
      staticClass: "text-center fs-largest darker bg-lighter border-medium radius-normal py-1 px-1 mx-2",
      staticStyle: {
        "width": "3rem"
      },
      attrs: {
        "type": "text",
        "disabled": _vm.readOnly,
        "value": "0"
      },
      domProps: {
        "value": (personPrice.quantityToBook)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(personPrice, "quantityToBook", _vm._n($event.target.value))
        }, function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "lazy", undefined, $event.key, undefined)) { return null; }
          _vm.paxManuallyChanged(personPrice), _vm.updateCalculations()
        }],
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn fs-largest bg-lightest dark border-medium py-1 px-3 h-100",
      attrs: {
        "disabled": _vm.readOnly
      },
      on: {
        "click": function($event) {
          return _vm.addPerson(personPrice)
        }
      }
    }, [_vm._v(" + ")])])]) : _vm._e()])
  }), 0)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-784b450e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-784b450e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Resume/Details/PersonTicketSelector.vue
// module id = 2807
// module chunks = 0